module.exports = "/images/the-philippine-star.png?1442725baf5844f0f0de2d0ff3d9f2df";